module.exports = __webpack_public_path__ + "img/main_cdy.625357d9.jpg";